module.exports = __webpack_public_path__ + "img/Scanvaegt7.dc657513.png";